import { exportToExcel } from "../../services/fetch-data.service";
import SasbReportData from "./SasbReportData";
import useFetch from "../../hooks/useFetch";
const EXPORT_SASB_API = 'https://api.suspro.io/api/v1/export-sasb'

const SasbReport = () => {

    const { data, isLoading } = useFetch('export-sasb?json_data=true')

    const exportSasbReport = () => {
        exportToExcel(EXPORT_SASB_API, 'sasbReport')
    };

    if (isLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"><i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">SASB Report</h1>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <div className="btn-group me-2 top-filter">
                            <label>Filter&nbsp;by</label>
                            <input className='form-control' type="date" />
                            {/* <select class="form-select" aria-label="Default select example">
                                <option selected>Open this select menu</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </select> */}
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={exportSasbReport}>Export</button>
                        </div>

                    </div>
                </div>


                <div className="esg-report">


                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Supplier name</th>
                                <th scope="col">Year</th>
                                <th scope="col">Category</th>
                                <th scope="col">Question</th>
                                <th scope="col">Details</th>
                                {/* <th scope="col">More details</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <SasbReportData data={data} />
                        </tbody>

                    </table>
                </div>
            </main>

        </>
    )
}

export default SasbReport;